module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tooltip', {
    attrs: {
      "content": "Add Rule",
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "fa fa-plus",
    attrs: {
      "id": "addCampaignBtn",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.createRuleDialogVisible = true
      }
    }
  })], 1), _vm._v(" "), _c('rule-create', {
    attrs: {
      "visible": _vm.createRuleDialogVisible,
      "campaign": _vm.campaign
    },
    on: {
      "close": function($event) {
        _vm.createRuleDialogVisible = false
      }
    }
  }), _vm._v(" "), _c('rule-edit', {
    attrs: {
      "rule": _vm.currentRule,
      "loading": _vm.loadingRule,
      "saving": _vm.updatingRule,
      "visible": _vm.editRuleDialogVisible,
      "campaign": _vm.campaign
    },
    on: {
      "close": function($event) {
        _vm.editRuleDialogVisible = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ibox float-e-margins"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingRules),
      expression: "loadingRules"
    }],
    ref: "rulesTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.rules,
      "empty-text": "No rules configured"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Rule",
      "prop": "title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Channel Rules")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4919e36a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/rules/RulesList.vue
// module id = 3266
// module chunks = 3